export default __webpack_public_path__ + "static/media/error_img.2fe8d040.png";